module.exports = __webpack_public_path__ + "img/app-access-copy.f1daa21d.svg";